import Button from '@/components/Base/Button';
import { TOrder } from '@/services/chefService';
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next';
import defaultAvatar from "@/assets/images/default.jpg";
import { Business } from '@/config';
import { TabButtonStatus as Status } from "@/enum/tabButtonStatus";
import ListItem from './ListItem';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

interface ChefMobileProps {
    orders: TOrder[];
    isLoading: boolean;
    status: Status;
    shop: Business;
    setDialogAcceptAll: Dispatch<SetStateAction<boolean>>;
    setDialogAccept: Dispatch<SetStateAction<boolean>>;
    setSelectedOrder: React.Dispatch<React.SetStateAction<TOrder | null>>
}

export default function ChefMobile({ orders, isLoading, status, shop, setDialogAcceptAll, setDialogAccept, setSelectedOrder }: ChefMobileProps) {
    const { t } = useTranslation();

    return (
        <>
            {
                isLoading ?
                    <div className="h-[calc(100vh-8.5rem)] bg-white flex flex-col items-center justify-center">
                        <AiOutlineLoading3Quarters size={32} className="animate-spin inline-block text-[#767676]" />
                    </div>
                    :
                    <div className="px-1 py-2 bg-white rounded-md h-[calc(100vh-8.5rem)] flex flex-col">
                        <div className="flex-1 overflow-y-auto">
                            {
                                orders.length ?
                                    orders.map((order, index) =>
                                        <ListItem
                                            key={index}
                                            order={order}
                                            setDialogAccept={setDialogAccept}
                                            setSelectedOrder={setSelectedOrder}
                                            shop={shop}
                                            status={status}
                                        />
                                    )
                                    :
                                    <div className="h-[calc(100vh-15rem)] bg-white flex flex-col items-center justify-center">
                                        <div className="flex flex-col items-center">
                                            <img
                                                className="w-24 h-24"
                                                src={defaultAvatar}
                                                alt=""
                                            />
                                            <div className="text-base font-semibold mt-5">{t("noOrders")}</div>
                                        </div>
                                    </div>
                            }
                        </div>

                        {
                            status === 'Ready' &&
                            <div className="">
                                <div className="border-b"></div>
                                <div className="flex justify-end gap-3 pt-2">
                                    <Button
                                        disabled={status === 'Ready' && orders.length === 0}
                                        className="ml-3 bg-green-500 border-none rounded-full text-white"
                                        onClick={() => setDialogAcceptAll(true)}
                                    >
                                        {t("doneAll")}
                                    </Button>
                                </div>
                            </div>
                        }

                    </div>
            }
        </>
    )
}
